import { render } from "./ConfirmHideContactsChangeModal.vue?vue&type=template&id=cd3814e8&ts=true"
import script from "./ConfirmHideContactsChangeModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmHideContactsChangeModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__